import useDataLoader from '~/hooks/shared/useDataLoader';
import {get_desks_filter_options} from '~/api/zero-api';


export default function useDesksFiltersLoader() {
    return useDataLoader(get_desks_filter_options);
}